import { render } from "./TakeLine.vue?vue&type=template&id=715d2e15"
import script from "./TakeLine.vue?vue&type=script&lang=js"
export * from "./TakeLine.vue?vue&type=script&lang=js"

import "./TakeLine.vue?vue&type=style&index=0&id=715d2e15&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__